export default __webpack_public_path__ + "static/bannerBackgroundImage-b0df556a5c370da5f06879040028e7f3.jpg";